import { crudActions } from "./CrudActions"

export default {
    ...crudActions("progressions"),
}